import Http from 'axios'
import {
    API_URL,
    VERSION
} from '../../config/config'
import moment from "moment";

function initialState() {
    return {
        visa_types: [],
        visa_type: {},
        conditions: [],
        loading: false,
        can_insert_day: false,
        first_time: false,
        overstay: false,
        free_days: 0,
        custom_conditions: [],
        //No of days in which year is completed
        min_age_days_remaining: false,
        min_age: 0,
        visa_type_slug: null,
        extend_condition: [],
        border_case_extend_condition: [],
        remaining_days: null,
        stay_days:null,
        old_visa: false,
        selected_condition: [],
        borderCaseReachedDay:0,
    }
}

const getters = {
    visa_types: state => state.visa_types,
    visa_type: state => state.visa_type,
    conditions: state => state.conditions,
    custom_conditions: state => state.custom_conditions,
    free_days: state => state.free_days,
    overstay: state => state.overstay,
    can_insert_day: state => state.can_insert_day,
    loading: state => state.loading,
    condition: state => state.selected_condition,
    min_age_days_remaining: state => state.min_age_days_remaining,
    min_age: state => state.min_age,
    visa_type_slug: state => state.visa_type_slug,
    extend_condition: state => state.extend_condition,
    border_case_extend_condition: state => state.border_case_extend_condition,
    remaining_days: state => state.remaining_days,
    stay_days: state => state.stay_days,
    old_visa: state => state.old_visa,
    late_cost(state, getters, rootState) {
        const visa_detail = rootState.VisaSingle.extendConvertVisaDetail;
        const extend_convert_data = rootState.VisaSingle.extendConvertData

        console.log(state.extend_condition);
        if (state.border_case_extend_condition.length > 0) {
            var condition = state.border_case_extend_condition.find(i => i.id === extend_convert_data.border_condition);
        } else {
            var condition = state.extend_condition.find(i => i.id === extend_convert_data.condition);
        }


        let late_days = state.borderCaseReachedDay > 0  && visa_detail.late_days > state.borderCaseReachedDay ? visa_detail.late_days - state.borderCaseReachedDay : visa_detail.late_days;

        let selected_day = [];
        // if (visa_detail.slug === 'tourist-visa') {
        //     return late_days * visa_detail.late_fee_per_day;
        // }
        if (condition !== undefined && late_days > 0) {
            const days = condition.days;
            for (let i = 0; i < days.length; i++) {
                if (parseInt(days[i].days) >= late_days) {
                    selected_day = days[i];
                    break;
                }
            }
        }

        if (selected_day && selected_day.late_stay_cost) {
            return parseInt(selected_day.late_stay_cost);
        }

        return 0;
    }
};

const actions = {
    fetchConditionByVisaTypeSlug({commit}, slug) {
        Http.get(`${API_URL}${VERSION}/visa-type-condition?slug=` + slug).then((response) => {
            commit('setConditions', response.data)
        })
    },
    async fetchConditionForDependentExtend(state, data) {
        const visa_detail = this.getters['VisaSingle/extendConvertVisaDetail'];
        const extend_convert_data = this.getters['VisaSingle/extendConvertData'];
        const response = await Http.get(`${API_URL}${VERSION}/get-dependent-visa-type-condition`, {
            params: {
                visa_number: visa_detail.visa_number,
                type: data,
                token: visa_detail.token,
                dependent_passport_number: extend_convert_data.dependent_passport_number,
                dependent_visa_number: extend_convert_data.dependent_visa_number,
                custom_created: visa_detail.custom_created,
                dob: visa_detail.dob,
                visa_type: visa_detail.visa_type,
                country_id: visa_detail.country_id
            }
        })
        state.commit('setExtendConditions', response.data);
        return response.data;
    },
    fetchConditionForConvert(state, data) {
        return new Promise(((resolve, reject) => {
            const visa_detail = this.getters['VisaSingle/extendConvertVisaDetail'];
            const extend_convert_data = this.getters['VisaSingle/extendConvertData'];
            Http.get(`${API_URL}${VERSION}/visa-type-convert-condition`, {
                params: {
                    visa_number: visa_detail.visa_number,
                    passport_number: visa_detail.passport_number,
                    type: data.type,
                    token: visa_detail.token,
                    dependent_passport_number: extend_convert_data.dependent_passport_number,
                    dependent_visa_number: extend_convert_data.dependent_visa_number,
                    custom_created: visa_detail.custom_created,
                    dob: visa_detail.dob,
                    visa_type: visa_detail.visa_type,
                    country_id: visa_detail.country_id,
                    isIndianHost:extend_convert_data.isIndianHost
                }
            }).then((response) => {
                let filteredItems;
                if (response && response.data && response.data.slug === 'consular-gratis-visa') {
                    filteredItems = response.data.data;
                } else {
                    filteredItems = response.data.data.filter(item => !item.name.includes('MVE/EAT/Migration'));
                }
                // const filteredItems = response.data.data.filter(item => !item.name.includes('MVE/EAT/Migration'));
                state.commit('setConditionsOnly', filteredItems);
                state.commit('setConvertSlug', response.data.slug);
                state.commit('setExtendConditions', response.data.data);
                if (response.data.dependent_visa) {
                    this.commit('VisaSingle/setDependentVisaDetails', response.data.dependent_visa)
                }
                resolve(true)
            }).catch((error) => {
                this.commit('Notification/showError', error.response.data.message);
                reject(error)
            })
        }))
    },
    fetchBorderCaseConditionForConvert(state, data) {
        return new Promise(((resolve, reject) => {
            const visa_detail = this.getters['VisaSingle/extendConvertVisaDetail'];
            const extend_convert_data = this.getters['VisaSingle/extendConvertData'];
            Http.get(`${API_URL}${VERSION}/visa-type-convert-condition`, {
                params: {
                    visa_number: visa_detail.visa_number,
                    passport_number: visa_detail.passport_number,
                    type: data.type,
                    token: visa_detail.token,
                    dependent_passport_number: extend_convert_data.dependent_passport_number,
                    dependent_visa_number: extend_convert_data.dependent_visa_number,
                    custom_created: visa_detail.custom_created,
                    dob: data.dob?data.dob:visa_detail.dob,
                    visa_type: visa_detail.visa_type,
                    country_id: visa_detail.country_id,
                    isIndianHost:extend_convert_data.isIndianHost
                }
            }).then((response) => {
                const filteredItems = response.data.data.filter(item => item.name.includes('MVE/EAT/Migration') !== true)
                state.commit('setBorderCaseExtendConditions', filteredItems);
                state.commit('setConvertSlug', response.data.slug);
                // state.commit('setBorderCaseExtendConditions', response.data.data);
                if (response.data.dependent_visa) {
                    this.commit('VisaSingle/setDependentVisaDetails', response.data.dependent_visa)
                }
                resolve(true)
            }).catch((error) => {
                this.commit('Notification/showError', error.response.data.message);
                reject(error)
            })
        }))
    },
    fetchConditionsForExtend(state) {
        return new Promise(((resolve, reject) => {
            let visa_detail = this.getters['VisaSingle/extendConvertVisaDetail'];

            Http.get(`${API_URL}${VERSION}/visa-type-extend-condition`, {
                params: {
                    passport_number: visa_detail.passport_number,
                    visa_number: visa_detail.visa_number,
                    token: visa_detail.token,
                    type: visa_detail.slug,
                    custom_created: visa_detail.custom_created,
                    dob: visa_detail.dob,
                    visa_type: visa_detail.visa_type,
                    country_id: visa_detail.country_id
                }
            }).then(({data}) => {
                if (data.conditions.length === 1) {
                    this.commit('VisaSingle/setExtendConvertDataCondition', data.conditions[0].id)
                }
                state.commit('setExtendConditions', data.conditions);
                state.commit('setRemainingDays', data.remaining_days);
                state.commit('setStayDays', data.stay_days);
                state.commit('setOldVisa', data.old);
                resolve(true)
            }).catch((error) => {
                reject(error)
            })
        }))
    },
    fetchBorderCaseConditionsForExtend(state, dob) {
        return new Promise(((resolve, reject) => {
            let visa_detail = this.getters['VisaSingle/extendConvertVisaDetail'];

            Http.get(`${API_URL}${VERSION}/visa-type-extend-condition`, {
                params: {
                    visa_number: visa_detail.visa_number,
                    token: visa_detail.token,
                    type: visa_detail.slug,
                    custom_created: visa_detail.custom_created,
                    dob: dob,
                    visa_type: visa_detail.visa_type,
                    country_id: visa_detail.country_id
                }
            }).then(({data}) => {
                if (data.conditions.length === 1) {
                    this.commit('VisaSingle/setExtendConvertDataConditionForBorderCase', data.conditions[0].id)
                }
                state.commit('setBorderCaseExtendConditions', data.conditions);
                state.commit('setOldVisa', data.old);
                resolve(true)
            }).catch((error) => {
                reject(error)
            })
        }))
    },
    // fetchConditionForDocuments
    fetchCondition({state, commit}) {
        return new Promise((resolve, reject) => {
            let visa_detail = this.getters['VisaSingle/visa'];
            let passport_type = visa_detail.passport.passport_type;
            if (visa_detail.apply_with_traveller_document)
                passport_type = 'Travel document';
            Http.get(`${API_URL}${VERSION}/visa-type-condition`, {
                params: {
                    passport_type: passport_type,
                    passport_number: visa_detail.passport.passport_number,
                    country: visa_detail.traveller.country,
                    dob: visa_detail.traveller.dob,
                    visa_type: state.visa_type.slug,
                    apply_type: this.getters['VisaSingle/apply_type']
                }
            }).then((response) => {
                const data = response.data;
                data.conditions = data.conditions.filter(item => item.name.includes('MVE/EAT/Migration') !== true)
                commit('setConditions', data);
                resolve(data)
            }).catch((error) => {
                reject(error)
            })

        })
    },
    resetState({commit}) {
        commit('resetState')
    },
    async fetchVisaType({commit}) {
        try {
            const {data: {data}} = await Http.get(`${API_URL}${VERSION}/visa-types-tourist`)
            commit('setVisaTypes', data)
        } catch (e) {
        }
    },
    fetchPreviousStayDuration(state) {
        return new Promise(((resolve, reject) => {
            let visa_detail = this.getters['VisaSingle/extendConvertVisaDetail'];

            Http.get(`${API_URL}${VERSION}/check-previous-stay-duration`, {
                params: {
                    visa_number: visa_detail.visa_number,
                    passport_number: visa_detail.passport_number,
                    token: visa_detail.token,
                    type: visa_detail.slug,
                    custom_created: visa_detail.custom_created,
                    dob: visa_detail.dob,
                    visa_type: visa_detail.visa_type,
                    country_id: visa_detail.country_id
                }
            }).then(({data}) => {
                if (data.conditions.length === 1) {
                    this.commit('VisaSingle/setExtendConvertDataCondition', data.conditions[0].id)
                }
                state.commit('setExtendConditions', data.conditions);
                state.commit('setRemainingDays', data.remaining_days);
                state.commit('setStayDays', data.stay_days);
                state.commit('setOldVisa', data.old);
                resolve(true)
            }).catch((error) => {
                reject(error)
            })
        }))
    }
};

const mutations = {
    setConditions(state, item) {
        state.conditions = item.conditions;
        state.overstay = item.overstay;
        state.remaining_days = item.remaining_days;
    },
    setConditionsOnly(state, item) {
        state.conditions = item;
    },
    setExtendConditions(state, item) {
        state.extend_condition = item;
    },
    setRemainingDays(state, item) {
        state.remaining_days = item
    },
    setStayDays(state, item) {
        state.stay_days = item
    },
    setBorderCaseExtendConditions(state, item) {
        state.border_case_extend_condition = item;
    },
    setLoading(state, loading) {
        state.loading = loading
    },
    setSelectedCondition(state, item) {
        state.selected_condition = item;
    },
    setVisaType(state, item) {
        state.visa_type = item;
    },
    setConvertSlug(state, item) {
        state.visa_type_slug = item;
    },
    setOldVisa(state, old_visa) {
        state.old_visa = old_visa;
    },
    setVisaTypes(state, visa_types) {
        state.visa_types = visa_types
    },
    setArrivalVisaTypes(state) {
        state.visa_types = [
            {
                type: 'Tourist Visa',
                slug: 'tourist-visa'
            },
            {
                type: 'Transit Visa',
                slug: 'transit-visa'
            },
            {
                type: 'Diplomatic Visa',
                slug: 'diplomatic-visa'
            },
            {
                type: 'Official Visa',
                slug: 'official-visa'
            },
        ]
    },

    // eslint-disable-next-line no-unused-vars
    resetState(state) {
        state = Object.assign({}, initialState())
    },
};

export default {
    namespaced: true,
    state: initialState,
    getters,
    actions,
    mutations
}
